/**
 * Formats value as per passed varType
 *
 * @param value
 * @param varType
 */
export const formatValue = (
  value: any,
  varType:
    | "int"
    | "float"
    | "numeric"
    | "date"
    | "time"
    | "char"
    | ""
    | undefined
): string => {
  if (value === undefined || value === null) {
    return "";
  }

  switch (varType) {
    case "int":
    case "float":
    case "numeric":
      const num_value =
        varType === "int" ? parseInt(value, 10) : parseFloat(value);
      return isNaN(num_value)
        ? value.toLocaleString()
        : num_value.toLocaleString();
    case "date":
    case "time":
      const d = new Date(value);
      return !isNaN(d.valueOf())
        ? `${d.toDateString()}, ${d.toLocaleTimeString()}`
        : value.toLocaleString();
    case "":
    case undefined:
      if (typeof value === "number") {
        return value.toLocaleString();
      }
      if (!isNaN(value)) {
        return value.toLocaleString();
      }
      const v = new Date(value);
      return !isNaN(v.valueOf())
        ? `${v.toDateString()}, ${v.toLocaleTimeString()}`
        : value.toLocaleString();
    default:
      return value.toLocaleString();
  }
};
